import { render, staticRenderFns } from "./messageManagement.vue?vue&type=template&id=9ef3af5e&scoped=true"
import script from "./messageManagement.vue?vue&type=script&lang=js"
export * from "./messageManagement.vue?vue&type=script&lang=js"
import style0 from "./messageManagement.vue?vue&type=style&index=0&id=9ef3af5e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef3af5e",
  null
  
)

export default component.exports